/**
 * 3 TINKERS PINK - HOLIDAY THEME ENGINE
 * Auto-applies holiday themes based on date
 * BILLION DOLLAR THEMING SYSTEM
 */

(function() {
  'use strict';

  // ========================================
  // HOLIDAY CONFIGURATION
  // ========================================
  const HOLIDAYS = {
    newYear: {
      name: "New Year's Celebration",
      startMonth: 12, startDay: 30,
      endMonth: 1, endDay: 7,
      colors: {
        primary: '#D4AF37',      // Gold
        secondary: '#C0C0C0',    // Silver
        accent: '#1C2C2C',       // Dark
        glow: 'rgba(212, 175, 55, 0.4)',
        gradient: 'linear-gradient(135deg, #D4AF37 0%, #C0C0C0 50%, #D4AF37 100%)'
      },
      decorations: 'confetti',
      badge: 'New Year Sale',
      message: 'Start the Year with Something Special',
      promoBar: 'NEW YEAR, NEW RINGS — Free Engraving on All Orders'
    },

    valentines: {
      name: "Valentine's Day",
      startMonth: 2, startDay: 7,
      endMonth: 2, endDay: 14,
      colors: {
        primary: '#E91E63',      // Pink
        secondary: '#FF5722',    // Coral
        accent: '#880E4F',       // Deep Pink
        glow: 'rgba(233, 30, 99, 0.4)',
        gradient: 'linear-gradient(135deg, #E91E63 0%, #FF5722 100%)'
      },
      decorations: 'hearts',
      badge: 'Valentine\'s Gift',
      message: 'Say I Love You Forever',
      promoBar: 'VALENTINE\'S SPECIAL — Couples Rings 15% Off'
    },

    stPatricks: {
      name: "St. Patrick's Day",
      startMonth: 3, startDay: 14,
      endMonth: 3, endDay: 17,
      colors: {
        primary: '#2E7D32',      // Green
        secondary: '#D4AF37',    // Gold
        accent: '#1B5E20',       // Dark Green
        glow: 'rgba(46, 125, 50, 0.4)',
        gradient: 'linear-gradient(135deg, #2E7D32 0%, #D4AF37 100%)'
      },
      decorations: 'clovers',
      badge: 'Lucky Find',
      message: 'Get Lucky in Love',
      promoBar: 'ST. PATRICK\'S DAY — Free Shipping All Weekend'
    },

    easter: {
      name: "Easter",
      startMonth: 4, startDay: 1,
      endMonth: 4, endDay: 21,
      colors: {
        primary: '#BA68C8',      // Lavender Purple
        secondary: '#81D4FA',    // Light Blue
        accent: '#AED581',       // Light Green
        glow: 'rgba(186, 104, 200, 0.4)',
        gradient: 'linear-gradient(135deg, #BA68C8 0%, #81D4FA 50%, #AED581 100%)'
      },
      decorations: 'eggs',
      badge: 'Spring Special',
      message: 'Spring into Something Beautiful',
      promoBar: 'EASTER SPECIAL — Spring Designs Now Available'
    },

    mothersDay: {
      name: "Mother's Day",
      startMonth: 5, startDay: 5,
      endMonth: 5, endDay: 12,
      colors: {
        primary: '#EC407A',      // Soft Pink
        secondary: '#AB47BC',    // Lavender
        accent: '#7B1FA2',       // Purple
        glow: 'rgba(236, 64, 122, 0.4)',
        gradient: 'linear-gradient(135deg, #EC407A 0%, #AB47BC 100%)'
      },
      decorations: 'flowers',
      badge: 'Perfect for Mom',
      message: 'A Ring She\'ll Treasure Forever',
      promoBar: 'MOTHER\'S DAY — Free Gift Wrapping + Card'
    },

    fathersDay: {
      name: "Father's Day",
      startMonth: 6, startDay: 10,
      endMonth: 6, endDay: 16,
      colors: {
        primary: '#1565C0',      // Navy
        secondary: '#D4AF37',    // Gold
        accent: '#0D47A1',       // Deep Blue
        glow: 'rgba(21, 101, 192, 0.4)',
        gradient: 'linear-gradient(135deg, #1565C0 0%, #D4AF37 100%)'
      },
      decorations: 'none',
      badge: 'For Dad',
      message: 'For the Man Who Has Everything',
      promoBar: 'FATHER\'S DAY — Men\'s Rings 10% Off'
    },

    july4th: {
      name: "4th of July",
      startMonth: 7, startDay: 1,
      endMonth: 7, endDay: 4,
      colors: {
        primary: '#B71C1C',      // Red
        secondary: '#1565C0',    // Blue
        accent: '#FFFFFF',       // White
        glow: 'rgba(183, 28, 28, 0.4)',
        gradient: 'linear-gradient(135deg, #B71C1C 0%, #FFFFFF 50%, #1565C0 100%)'
      },
      decorations: 'fireworks',
      badge: 'USA Made',
      message: 'Celebrate Freedom & Love',
      promoBar: '4TH OF JULY — Up to 20% Off All Rings'
    },

    halloween: {
      name: "Halloween",
      startMonth: 10, startDay: 20,
      endMonth: 10, endDay: 31,
      colors: {
        primary: '#FF6F00',      // Orange
        secondary: '#1C1C1C',    // Black
        accent: '#6A1B9A',       // Purple
        glow: 'rgba(255, 111, 0, 0.5)',
        gradient: 'linear-gradient(135deg, #FF6F00 0%, #6A1B9A 100%)'
      },
      decorations: 'spooky',
      badge: 'Spooky Style',
      message: 'Hauntingly Beautiful Rings',
      promoBar: 'HALLOWEEN SALE — Treat Yourself to 15% Off'
    },

    thanksgiving: {
      name: "Thanksgiving",
      startMonth: 11, startDay: 20,
      endMonth: 11, endDay: 23,
      colors: {
        primary: '#BF360C',      // Burnt Orange
        secondary: '#5D4037',    // Brown
        accent: '#D4AF37',       // Gold
        glow: 'rgba(191, 54, 12, 0.4)',
        gradient: 'linear-gradient(135deg, #BF360C 0%, #D4AF37 100%)'
      },
      decorations: 'leaves',
      badge: 'Give Thanks',
      message: 'Grateful for Love',
      promoBar: 'THANKSGIVING — Free Shipping on Orders $50+'
    },

    blackFriday: {
      name: "Black Friday",
      startMonth: 11, startDay: 24,
      endMonth: 11, endDay: 27,
      colors: {
        primary: '#1C1C1C',      // Black
        secondary: '#D4AF37',    // Gold
        accent: '#FF1744',       // Red accent
        glow: 'rgba(212, 175, 55, 0.5)',
        gradient: 'linear-gradient(135deg, #1C1C1C 0%, #D4AF37 100%)'
      },
      decorations: 'sale',
      badge: 'BLACK FRIDAY',
      message: 'Biggest Sale of the Year!',
      promoBar: 'BLACK FRIDAY — Up to 30% Off Everything'
    },

    christmas: {
      name: "Christmas",
      startMonth: 12, startDay: 1,
      endMonth: 12, endDay: 25,
      colors: {
        primary: '#C62828',      // Red
        secondary: '#2E7D32',    // Green
        accent: '#D4AF37',       // Gold
        glow: 'rgba(198, 40, 40, 0.4)',
        gradient: 'linear-gradient(135deg, #C62828 0%, #2E7D32 100%)'
      },
      decorations: 'snow',
      badge: 'Holiday Gift',
      message: 'Give the Gift of Forever',
      promoBar: 'HOLIDAY SPECIAL — Free Express Shipping'
    }
  };

  // ========================================
  // CORE ENGINE
  // ========================================
  
  const HolidayEngine = {
    currentHoliday: null,
    isActive: false,

    init: function() {
      this.detectHoliday();
      if (this.currentHoliday) {
        this.applyTheme();
        console.log('[Holiday] Theme Active:', this.currentHoliday.name);
      } else {
        console.log('📅 No active holiday theme');
      }
    },

    detectHoliday: function() {
      // ========================================
      // PRIORITY 1: Check for PREVIEW MODE (set by Theme Settings)
      // Body will have class like: tp-holiday-active tp-holiday-valentines tp-holiday-preview
      // ========================================
      const bodyClasses = document.body.className;
      
      if (bodyClasses.includes('tp-holiday-preview')) {
        // Extract the holiday key from body class
        const holidayMatch = bodyClasses.match(/tp-holiday-(\w+)/g);
        if (holidayMatch) {
          for (const match of holidayMatch) {
            const key = match.replace('tp-holiday-', '');
            // Skip 'active' and 'preview' - we want the actual holiday name
            if (key !== 'active' && key !== 'preview' && HOLIDAYS[key]) {
              this.currentHoliday = { key, ...HOLIDAYS[key] };
              this.isActive = true;
              console.log('[Holiday] PREVIEW MODE - Using:', key, HOLIDAYS[key].name);
              return;
            }
          }
        }
      }
      
      // ========================================
      // PRIORITY 2: Date-based detection (normal mode)
      // ========================================
      const now = new Date();
      const month = now.getMonth() + 1; // JS months are 0-indexed
      const day = now.getDate();
      
      console.log('Detecting holiday for:', month + '/' + day);

      for (const [key, holiday] of Object.entries(HOLIDAYS)) {
        if (holiday.disabled) {
          console.log('Holiday disabled:', key);
          continue;
        }
        if (this.isDateInRange(month, day, holiday)) {
          this.currentHoliday = { key, ...holiday };
          this.isActive = true;
          console.log('Holiday detected:', key, holiday.name);
          return;
        }
      }
      console.log('No holiday matches current date');
    },

    isDateInRange: function(month, day, holiday) {
      const { startMonth, startDay, endMonth, endDay } = holiday;
      
      // Handle year wrap (e.g., Dec 30 - Jan 7)
      if (startMonth > endMonth) {
        return (month === startMonth && day >= startDay) ||
               (month === endMonth && day <= endDay) ||
               (month > startMonth) || (month < endMonth);
      }
      
      // Same month
      if (startMonth === endMonth) {
        return month === startMonth && day >= startDay && day <= endDay;
      }
      
      // Different months, same year
      return (month === startMonth && day >= startDay) ||
             (month === endMonth && day <= endDay) ||
             (month > startMonth && month < endMonth);
    },

    applyTheme: function() {
      if (!this.currentHoliday) return;
      
      const settings = this.settings || {};
      console.log('Applying theme:', this.currentHoliday.name);

      // Apply CSS variables
      this.applyColors();
      
      // Add promo bar (if enabled)
      if (settings.showPromoBar !== false) {
        this.addPromoBar();
      }
      
      // Add decorations (if enabled)
      if (settings.showDecorations !== false) {
        this.addDecorations();
      }
      
      // Add product badges (if enabled)
      if (settings.showProductBadges !== false) {
        this.addProductBadges();
      }
      
      // Mark body with holiday class (may already be set server-side)
      if (!document.body.classList.contains('tp-holiday-active')) {
        document.body.classList.add('tp-holiday-active');
      }
      if (!document.body.classList.contains('tp-holiday-' + this.currentHoliday.key)) {
        document.body.classList.add('tp-holiday-' + this.currentHoliday.key);
      }
    },

    applyColors: function() {
      const { colors } = this.currentHoliday;
      const root = document.documentElement;
      
      root.style.setProperty('--tp-holiday-primary', colors.primary);
      root.style.setProperty('--tp-holiday-secondary', colors.secondary);
      root.style.setProperty('--tp-holiday-accent', colors.accent);
      root.style.setProperty('--tp-holiday-glow', colors.glow);
      root.style.setProperty('--tp-holiday-gradient', colors.gradient);
    },

    addPromoBar: function() {
      // Premium SVG icons for promo bar
      const sparkleLeft = '<svg class="tp-promo-icon tp-promo-icon--left" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M12 0L14.59 8.41L23 11L14.59 13.59L12 22L9.41 13.59L1 11L9.41 8.41L12 0Z"/></svg>';
      const sparkleRight = '<svg class="tp-promo-icon tp-promo-icon--right" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M12 0L14.59 8.41L23 11L14.59 13.59L12 22L9.41 13.59L1 11L9.41 8.41L12 0Z"/></svg>';
      
      // Strip ALL emojis from promo text - keep it clean!
      let promoText = this.currentHoliday.promoBar || '';
      promoText = promoText.replace(/[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2300}-\u{23FF}]|[\u{2B50}]|[\u{1FA00}-\u{1FAFF}]|[\u{FE00}-\u{FE0F}]|[\u{200D}]|[✨🎆🎉🎄🎁💕💐☘️🦃🔥🎃👻🇺🇸👔]/gu, '').trim();
      
      // Build premium promo text with SVG icons
      const promoHTML = sparkleLeft + ' <span class="tp-promo-text-inner">' + promoText + '</span> ' + sparkleRight;
      
      // NEW APPROACH: Update the EXISTING header promo bar text instead of creating a new one
      const existingPromoText = document.querySelector('.tp-promo-bar__text');
      if (existingPromoText) {
        existingPromoText.innerHTML = promoHTML;
        console.log('Updated existing promo bar with premium SVG icons');
        return;
      }
      
      // Fallback: try other selectors
      const existingPromo = document.querySelector('.tp-promo-bar p, .tp-promo-bar');
      if (existingPromo) {
        if (existingPromo.tagName === 'P') {
          existingPromo.innerHTML = promoHTML;
        } else {
          const p = existingPromo.querySelector('p');
          if (p) p.innerHTML = promoHTML;
        }
        console.log('Updated promo bar via fallback selector');
        return;
      }
      
      console.log('No existing promo bar found to update');
    },

    addDecorations: function() {
      const type = this.currentHoliday.decorations;
      if (type === 'none') return;

      // Create decoration container
      let container = document.querySelector('.tp-holiday-decorations');
      if (!container) {
        container = document.createElement('div');
        container.className = 'tp-holiday-decorations';
        document.body.appendChild(container);
      }

      // Generate decorations based on type
      switch (type) {
        case 'confetti':
          this.createConfetti(container);
          break;
        case 'hearts':
          this.createHearts(container);
          break;
        case 'snow':
          this.createSnow(container);
          break;
        case 'clovers':
          this.createClovers(container);
          break;
        case 'flowers':
          this.createFlowers(container);
          break;
        case 'fireworks':
          this.createFireworks(container);
          break;
        case 'spooky':
          this.createSpooky(container);
          break;
        case 'leaves':
          this.createLeaves(container);
          break;
        case 'sale':
          this.createSaleTags(container);
          break;
      }
    },

    // ========================================
    // DECORATION GENERATORS
    // ========================================

    createConfetti: function(container) {
      const colors = ['#D4AF37', '#C0C0C0', '#FFD700', '#FFF', '#1C2C2C'];
      for (let i = 0; i < 50; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'tp-decoration tp-confetti';
        confetti.style.cssText = `
          left: ${Math.random() * 100}%;
          background: ${colors[Math.floor(Math.random() * colors.length)]};
          animation-delay: ${Math.random() * 5}s;
          animation-duration: ${3 + Math.random() * 4}s;
        `;
        container.appendChild(confetti);
      }
    },

    // SVG Decoration Icons (brand compliant - no emojis)
    decorationSVGs: {
      heart: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>',
      snow: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M11 1v4.07c-.53.06-1.03.24-1.46.52L7.41 3.46 6 4.87l2.13 2.13c-.28.43-.46.93-.52 1.46H3.54v2h4.07c.06.53.24 1.03.52 1.46L6 14.05l1.41 1.41 2.13-2.13c.43.28.93.46 1.46.52V18h2v-4.07c.53-.06 1.03-.24 1.46-.52l2.13 2.13L18 14.13l-2.13-2.13c.28-.43.46-.93.52-1.46H20.46v-2h-4.07c-.06-.53-.24-1.03-.52-1.46L18 4.95l-1.41-1.41-2.13 2.13c-.43-.28-.93-.46-1.46-.52V1h-2zm1 7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"/></svg>',
      clover: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C9.79 2 8 3.79 8 6c0 1.1.45 2.1 1.17 2.83L12 12l2.83-3.17C15.55 8.1 16 7.1 16 6c0-2.21-1.79-4-4-4zm-6 6c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.1 0 2.1-.45 2.83-1.17L12 12l-3.17-2.83C8.1 8.45 7.1 8 6 8zm12 0c-1.1 0-2.1.45-2.83 1.17L12 12l3.17 2.83C15.9 15.55 16.9 16 18 16c2.21 0 4-1.79 4-4s-1.79-4-4-4zm-6 6l-2.83 3.17C8.45 17.9 8 18.9 8 20c0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.1-.45-2.1-1.17-2.83L12 14z"/></svg>',
      flower: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 3.12 13.38 2 12 2S9.5 3.12 9.5 4.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"/></svg>',
      sparkle: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 0L14.59 8.41L23 11L14.59 13.59L12 22L9.41 13.59L1 11L9.41 8.41L12 0Z"/></svg>',
      moon: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/></svg>',
      leaf: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75C7 8 17 8 17 8z"/></svg>',
      tag: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>',
      star: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>'
    },

    createHearts: function(container) {
      const svg = this.decorationSVGs.heart;
      for (let i = 0; i < 20; i++) {
        const heart = document.createElement('div');
        heart.className = 'tp-decoration tp-heart';
        heart.innerHTML = svg;
        const size = 12 + Math.random() * 16;
        heart.style.cssText = `
          left: ${Math.random() * 100}%;
          width: ${size}px;
          height: ${size}px;
          color: #E91E63;
          animation-delay: ${Math.random() * 5}s;
          animation-duration: ${4 + Math.random() * 4}s;
        `;
        container.appendChild(heart);
      }
    },

    createSnow: function(container) {
      const svg = this.decorationSVGs.snow;
      for (let i = 0; i < 40; i++) {
        const snow = document.createElement('div');
        snow.className = 'tp-decoration tp-snow';
        snow.innerHTML = svg;
        const size = 10 + Math.random() * 14;
        snow.style.cssText = `
          left: ${Math.random() * 100}%;
          width: ${size}px;
          height: ${size}px;
          color: rgba(255,255,255,${0.5 + Math.random() * 0.5});
          animation-delay: ${Math.random() * 10}s;
          animation-duration: ${5 + Math.random() * 10}s;
        `;
        container.appendChild(snow);
      }
    },

    createClovers: function(container) {
      const svg = this.decorationSVGs.clover;
      for (let i = 0; i < 15; i++) {
        const clover = document.createElement('div');
        clover.className = 'tp-decoration tp-clover';
        clover.innerHTML = svg;
        const size = 14 + Math.random() * 14;
        clover.style.cssText = `
          left: ${Math.random() * 100}%;
          width: ${size}px;
          height: ${size}px;
          color: #2E7D32;
          animation-delay: ${Math.random() * 5}s;
          animation-duration: ${4 + Math.random() * 4}s;
        `;
        container.appendChild(clover);
      }
    },

    createFlowers: function(container) {
      const svg = this.decorationSVGs.flower;
      const colors = ['#EC407A', '#AB47BC', '#E91E63', '#F48FB1', '#CE93D8'];
      for (let i = 0; i < 15; i++) {
        const flower = document.createElement('div');
        flower.className = 'tp-decoration tp-flower';
        flower.innerHTML = svg;
        const size = 14 + Math.random() * 14;
        flower.style.cssText = `
          left: ${Math.random() * 100}%;
          width: ${size}px;
          height: ${size}px;
          color: ${colors[Math.floor(Math.random() * colors.length)]};
          animation-delay: ${Math.random() * 5}s;
          animation-duration: ${5 + Math.random() * 5}s;
        `;
        container.appendChild(flower);
      }
    },

    createFireworks: function(container) {
      const svg = this.decorationSVGs.sparkle;
      const colors = ['#D4AF37', '#C0C0C0', '#FFD700', '#FFFFFF'];
      for (let i = 0; i < 15; i++) {
        const fw = document.createElement('div');
        fw.className = 'tp-decoration tp-firework';
        fw.innerHTML = svg;
        const size = 16 + Math.random() * 16;
        fw.style.cssText = `
          left: ${Math.random() * 100}%;
          top: ${Math.random() * 50}%;
          width: ${size}px;
          height: ${size}px;
          color: ${colors[Math.floor(Math.random() * colors.length)]};
          animation-delay: ${Math.random() * 3}s;
        `;
        container.appendChild(fw);
      }
    },

    createSpooky: function(container) {
      const svg = this.decorationSVGs.moon;
      const colors = ['#FF6F00', '#6A1B9A', '#FFA000', '#9C27B0'];
      for (let i = 0; i < 15; i++) {
        const el = document.createElement('div');
        el.className = 'tp-decoration tp-spooky';
        el.innerHTML = svg;
        const size = 14 + Math.random() * 16;
        el.style.cssText = `
          left: ${Math.random() * 100}%;
          width: ${size}px;
          height: ${size}px;
          color: ${colors[Math.floor(Math.random() * colors.length)]};
          animation-delay: ${Math.random() * 5}s;
          animation-duration: ${4 + Math.random() * 4}s;
        `;
        container.appendChild(el);
      }
    },

    createLeaves: function(container) {
      const svg = this.decorationSVGs.leaf;
      const colors = ['#BF360C', '#E65100', '#FF6F00', '#D84315', '#8D6E63'];
      for (let i = 0; i < 20; i++) {
        const leaf = document.createElement('div');
        leaf.className = 'tp-decoration tp-leaf';
        leaf.innerHTML = svg;
        const size = 12 + Math.random() * 14;
        leaf.style.cssText = `
          left: ${Math.random() * 100}%;
          width: ${size}px;
          height: ${size}px;
          color: ${colors[Math.floor(Math.random() * colors.length)]};
          animation-delay: ${Math.random() * 5}s;
          animation-duration: ${4 + Math.random() * 5}s;
        `;
        container.appendChild(leaf);
      }
    },

    createSaleTags: function(container) {
      const svg = this.decorationSVGs.tag;
      for (let i = 0; i < 12; i++) {
        const tag = document.createElement('div');
        tag.className = 'tp-decoration tp-sale-tag';
        tag.innerHTML = svg;
        const size = 14 + Math.random() * 12;
        tag.style.cssText = `
          left: ${Math.random() * 100}%;
          width: ${size}px;
          height: ${size}px;
          color: #D4AF37;
          animation-delay: ${Math.random() * 5}s;
          animation-duration: ${3 + Math.random() * 4}s;
        `;
        container.appendChild(tag);
      }
    },

    addProductBadges: function() {
      // Add holiday badge to product cards
      const badge = this.currentHoliday.badge;
      document.querySelectorAll('.tp-product-card, .product-card, .cj-product').forEach(card => {
        if (card.querySelector('.tp-holiday-badge')) return;
        
        const badgeEl = document.createElement('div');
        badgeEl.className = 'tp-holiday-badge';
        badgeEl.textContent = badge;
        card.style.position = 'relative';
        card.appendChild(badgeEl);
      });
    },

    // ========================================
    // PUBLIC API
    // ========================================

    getHoliday: function() {
      return this.currentHoliday;
    },

    isHolidayActive: function() {
      return this.isActive;
    },

    forceHoliday: function(key) {
      if (HOLIDAYS[key]) {
        this.currentHoliday = { key, ...HOLIDAYS[key] };
        this.isActive = true;
        this.applyTheme();
      }
    },

    removeTheme: function() {
      document.body.classList.remove('tp-holiday-active');
      if (this.currentHoliday) {
        document.body.classList.remove('tp-holiday-' + this.currentHoliday.key);
      }
      
      const promo = document.querySelector('.tp-holiday-promo');
      if (promo) promo.remove();
      
      const decorations = document.querySelector('.tp-holiday-decorations');
      if (decorations) decorations.remove();
      
      document.querySelectorAll('.tp-holiday-badge').forEach(b => b.remove());
    }
  };

  // Load settings from control center
  HolidayEngine.loadSettings = function() {
    const settingsEl = document.getElementById('holiday-settings');
    console.log('Looking for holiday-settings element:', settingsEl);
    
    if (settingsEl) {
      try {
        const settings = JSON.parse(settingsEl.textContent);
        this.settings = settings;
        console.log('Holiday settings loaded:', settings);
        
        // Check master enable
        if (!settings.enabled) {
          console.log('Holiday themes DISABLED by master switch');
          this.isActive = false;
          return;
        }
        
        // Override holiday data with custom settings
        if (settings.holidays) {
          for (const [key, data] of Object.entries(settings.holidays)) {
            if (HOLIDAYS[key]) {
              // Mark as disabled if not enabled
              if (data.enabled === false) {
                HOLIDAYS[key].disabled = true;
              } else {
                HOLIDAYS[key].disabled = false;
                // Strip emojis from ALL user-entered text (brand compliant)
                if (data.badge) HOLIDAYS[key].badge = stripEmojis(data.badge);
                if (data.promoText) HOLIDAYS[key].promoBar = stripEmojis(data.promoText);
                // Only set image URLs if they're valid (start with http)
                const isValidUrl = (url) => url && url.length > 10 && (url.startsWith('http') || url.startsWith('//'));
                if (data.images && isValidUrl(data.images.heroDesktop)) HOLIDAYS[key].heroImage = data.images.heroDesktop;
                if (data.images && isValidUrl(data.images.heroMobile)) HOLIDAYS[key].heroMobile = data.images.heroMobile;
                if (data.images && isValidUrl(data.images.collectionBanner)) HOLIDAYS[key].collectionBanner = data.images.collectionBanner;
                if (data.images && isValidUrl(data.images.popup)) HOLIDAYS[key].popupImage = data.images.popup;
                if (data.images && isValidUrl(data.images.giftGuide)) HOLIDAYS[key].giftGuideImage = data.images.giftGuide;
                if (data.images && isValidUrl(data.images.productOverlay)) HOLIDAYS[key].productOverlay = data.images.productOverlay;
                if (data.title) HOLIDAYS[key].title = stripEmojis(data.title);
                if (data.subtitle) HOLIDAYS[key].subtitle = stripEmojis(data.subtitle);
                if (data.ctaText) HOLIDAYS[key].ctaText = stripEmojis(data.ctaText);
                if (data.ctaUrl) HOLIDAYS[key].ctaUrl = data.ctaUrl;
              }
            }
          }
        }
        
        console.log('Holiday settings applied successfully');
      } catch (e) {
        console.log('Error parsing holiday settings:', e);
      }
    } else {
      console.log('No holiday-settings element found - using defaults');
    }
  };

  // Update hero with holiday content
  HolidayEngine.updateHero = function() {
    if (!this.currentHoliday) return;
    
    const holiday = this.currentHoliday;
    console.log('Updating hero with:', holiday);
    
    // Update DESKTOP hero image if set
    if (holiday.heroImage && holiday.heroImage.length > 10) {
      console.log('Setting desktop hero image to:', holiday.heroImage);
      const heroSelectors = [
        '.tp-hero-desktop__bg img',
        '.tp-hero__bg img',
        '.tp-hero-bg img',
        '.tp-hero img'
      ];
      
      for (const selector of heroSelectors) {
        const heroImg = document.querySelector(selector);
        if (heroImg) {
          console.log('Found desktop hero image at:', selector);
          heroImg.src = holiday.heroImage;
          heroImg.srcset = '';
          break;
        }
      }
    }
    
    // Update MOBILE hero image if set
    if (holiday.heroMobile && holiday.heroMobile.length > 10) {
      console.log('Setting mobile hero image to:', holiday.heroMobile);
      const mobileSelectors = [
        '#tp-hero-mobile-img',
        '.tp-hero-mobile__bg img',
        '.tp-hero-mobile img',
        '[class*="hero-mobile"] img'
      ];
      
      for (const selector of mobileSelectors) {
        const mobileImg = document.querySelector(selector);
        if (mobileImg) {
          console.log('Found mobile hero image at:', selector);
          mobileImg.src = holiday.heroMobile;
          mobileImg.srcset = '';
          mobileImg.style.display = 'block';
          
          // Hide fallback gradient if present
          const fallback = document.querySelector('.tp-hero-mobile-fallback');
          if (fallback) fallback.style.display = 'none';
          
          console.log('Mobile hero updated successfully!');
          break;
        }
      }
    }
    
    // Update hero title if set
    if (holiday.title) {
      const titleSelectors = [
        '.tp-hero-desktop__title',
        '.tp-hero__title',
        '.tp-hero-title',
        '[class*="hero"] h1'
      ];
      
      for (const selector of titleSelectors) {
        const heroTitle = document.querySelector(selector);
        if (heroTitle) {
          console.log('Found hero title at:', selector);
          heroTitle.textContent = holiday.title;
          break;
        }
      }
    }
    
    // Update hero subtitle if set
    if (holiday.subtitle) {
      const subtitleSelectors = [
        '.tp-hero-desktop__subtitle',
        '.tp-hero__subtitle',
        '.tp-hero-subtitle',
        '[class*="hero"] p'
      ];
      
      for (const selector of subtitleSelectors) {
        const heroSubtitle = document.querySelector(selector);
        if (heroSubtitle) {
          console.log('Found hero subtitle at:', selector);
          heroSubtitle.textContent = holiday.subtitle;
          break;
        }
      }
    }
    
    // Update MOBILE hero text
    if (holiday.badge) {
      const mobileBadge = document.querySelector('.tp-hero-mobile__badge');
      if (mobileBadge) {
        mobileBadge.textContent = holiday.badge;
        console.log('Updated mobile badge:', holiday.badge);
      }
    }
    
    if (holiday.title) {
      const mobileTitle = document.querySelector('.tp-hero-mobile__title');
      if (mobileTitle) {
        mobileTitle.textContent = holiday.title;
        console.log('Updated mobile title:', holiday.title);
      }
    }
    
    if (holiday.subtitle) {
      const mobileSubtitle = document.querySelector('.tp-hero-mobile__subtitle');
      if (mobileSubtitle) {
        mobileSubtitle.textContent = holiday.subtitle;
        console.log('Updated mobile subtitle:', holiday.subtitle);
      }
    }
  };

  // Update collection banner with holiday content
  HolidayEngine.updateCollectionBanner = function() {
    if (!this.currentHoliday) return;
    
    const settings = this.settings || {};
    const holiday = this.currentHoliday;
    
    // Check if collection banner is enabled in settings
    if (settings.showCollectionBanner === false) {
      console.log('Collection banner disabled in settings');
      return;
    }
    
    // Check if we're on a collection page
    if (!window.location.pathname.includes('/collections/')) return;
    
    // Get collection banner image from settings
    const bannerImage = holiday.collectionBanner;
    if (!bannerImage || bannerImage.length < 10) {
      console.log('No collection banner image set for holiday');
      return;
    }
    
    console.log('Updating collection banner with:', bannerImage);
    
    // Try multiple selectors for collection banner
    const bannerSelectors = [
      '#tp-collection-banner-img img',
      '.tp-collection-hero__image img',
      '.tp-collection-hero__bg img',
      '.tp-collection-banner img',
      '.collection-hero img',
      '.collection-banner img',
      'collection-banner img',
      '[class*="collection"] [class*="hero"] img',
      '[class*="collection"] [class*="banner"] img'
    ];
    
    for (const selector of bannerSelectors) {
      const bannerImg = document.querySelector(selector);
      if (bannerImg) {
        console.log('Found collection banner at:', selector);
        bannerImg.src = bannerImage;
        bannerImg.srcset = '';
        bannerImg.style.display = 'block'; // Show if it was hidden
        bannerImg.classList.remove('tp-holiday-banner-placeholder');
        
        // Also show the parent container
        const parent = bannerImg.closest('.tp-collection-hero__image');
        if (parent) {
          parent.style.display = 'block';
        }
        
        console.log('Collection banner updated successfully!');
        break;
      }
    }
  };

  // Holiday popup text content
  const POPUP_TEXT = {
    newYear: {
      heading: 'Start 2026 in Style',
      content: 'Join our VIP list for exclusive New Year offers and early access to new designs.'
    },
    valentines: {
      heading: 'Love Deserves the Best',
      content: 'Get exclusive Valentine\'s offers and find the perfect ring for your forever person.'
    },
    stpatricks: {
      heading: 'Get Lucky in Love',
      content: 'Subscribe for exclusive St. Patrick\'s Day deals on our handcrafted rings.'
    },
    easter: {
      heading: 'Spring into Something Beautiful',
      content: 'Join our VIP list for exclusive Easter specials and new spring designs.'
    },
    mothers: {
      heading: 'Celebrate Her Love',
      content: 'Join us for exclusive Mother\'s Day offers on rings she\'ll treasure forever.'
    },
    fathers: {
      heading: 'Honor His Legacy',
      content: 'Get exclusive Father\'s Day deals on premium rings for the man who matters.'
    },
    july4th: {
      heading: 'Celebrate Freedom',
      content: 'Join our list for exclusive Independence Day offers on American-made rings.'
    },
    halloween: {
      heading: 'Hauntingly Beautiful',
      content: 'Get exclusive Halloween treats and spooky-good deals on unique rings.'
    },
    thanksgiving: {
      heading: 'Grateful for Love',
      content: 'Join us for exclusive Thanksgiving offers and give the gift of forever.'
    },
    blackFriday: {
      heading: 'Biggest Sale of the Year',
      content: 'Be first to access our Black Friday deals. Exclusive discounts await.'
    },
    christmas: {
      heading: 'The Gift of Forever',
      content: 'Get exclusive holiday offers and find the perfect ring under the tree.'
    }
  };

  // Update product overlay with holiday image
  HolidayEngine.updateProductOverlay = function() {
    if (!this.currentHoliday) return;
    
    const holiday = this.currentHoliday;
    const overlayImage = holiday.productOverlay;
    
    if (!overlayImage || overlayImage.length < 10) {
      console.log('No product overlay image set for holiday');
      return;
    }
    
    console.log('Applying product overlay:', overlayImage);
    
    // Only apply on product pages
    const isProductPage = window.location.pathname.includes('/products/');
    const isCollectionPage = window.location.pathname.includes('/collections/');
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '';
    
    if (isProductPage) {
      // Product detail page - add overlay to main product image area
      this.addProductPageOverlay(overlayImage);
    }
    
    if (isCollectionPage || isHomePage) {
      // Collection/Home - add overlay to product cards
      this.addProductCardOverlays(overlayImage);
    }
  };
  
  // Add overlay to product detail page
  HolidayEngine.addProductPageOverlay = function(overlayImage) {
    // Find the main product image container
    const productImageSelectors = [
      '.product-gallery',
      '.product__images',
      '.product__media-list',
      '.product-media',
      '[class*="product"] [class*="gallery"]',
      '[class*="product"] [class*="media"]'
    ];
    
    for (const selector of productImageSelectors) {
      const container = document.querySelector(selector);
      if (container) {
        // Check if overlay already exists
        if (container.querySelector('.tp-holiday-product-overlay')) return;
        
        // Create overlay element
        const overlay = document.createElement('div');
        overlay.className = 'tp-holiday-product-overlay';
        overlay.innerHTML = `<img src="${overlayImage}" alt="Holiday Edition" class="tp-holiday-overlay-img">`;
        
        // Position relative to container
        container.style.position = 'relative';
        container.appendChild(overlay);
        
        console.log('Product page overlay added to:', selector);
        break;
      }
    }
  };
  
  // Add overlays to product cards on collection/home pages
  HolidayEngine.addProductCardOverlays = function(overlayImage) {
    const cardSelectors = [
      '.product-card',
      '.cj-product',
      '.tp-product-card',
      '[class*="product-card"]',
      '[class*="product-item"]'
    ];
    
    let cardsFound = 0;
    
    for (const selector of cardSelectors) {
      const cards = document.querySelectorAll(selector);
      cards.forEach(card => {
        // Check if overlay already exists
        if (card.querySelector('.tp-holiday-card-overlay')) return;
        
        // Find the image container within the card
        const imageContainer = card.querySelector('.product-card__figure, .product-card__image, [class*="image"], figure, .cj-product-image');
        if (imageContainer) {
          // Create mini overlay
          const overlay = document.createElement('div');
          overlay.className = 'tp-holiday-card-overlay';
          overlay.innerHTML = `<img src="${overlayImage}" alt="Holiday">`;
          
          imageContainer.style.position = 'relative';
          imageContainer.appendChild(overlay);
          cardsFound++;
        }
      });
    }
    
    console.log('Product card overlays added:', cardsFound);
  };

  // Update popup with holiday image and text
  HolidayEngine.updatePopup = function() {
    if (!this.currentHoliday) return;
    
    const holiday = this.currentHoliday;
    const holidayKey = holiday.key;
    const popupImage = holiday.popupImage;
    
    // Update popup image
    if (popupImage && popupImage.length > 10) {
      console.log('Setting popup image to:', popupImage);
      
      const popupSelectors = [
        '#tp-popup-img',
        '.newsletter-popup__image',
        '.pop-in img',
        '[class*="popup"] img'
      ];
      
      for (const selector of popupSelectors) {
        const popupImg = document.querySelector(selector);
        if (popupImg) {
          console.log('Found popup image at:', selector);
          popupImg.src = popupImage;
          popupImg.style.display = 'block';
          console.log('Popup image updated successfully!');
          break;
        }
      }
    }
    
    // Update popup text
    const popupText = POPUP_TEXT[holidayKey];
    if (popupText) {
      // Update heading
      const headingSelectors = [
        '.newsletter-popup .h4',
        '.pop-in .h4',
        '.newsletter-popup h4',
        '.pop-in h4'
      ];
      
      for (const selector of headingSelectors) {
        const heading = document.querySelector(selector);
        if (heading) {
          heading.textContent = popupText.heading;
          console.log('Updated popup heading:', popupText.heading);
          break;
        }
      }
      
      // Update content/description
      const contentSelectors = [
        '.newsletter-popup .prose',
        '.newsletter-popup .prose p',
        '.pop-in .prose',
        '.pop-in .prose p'
      ];
      
      for (const selector of contentSelectors) {
        const content = document.querySelector(selector);
        if (content) {
          content.textContent = popupText.content;
          console.log('Updated popup content:', popupText.content);
          break;
        }
      }
    }
  };

  // ========================================
  // UTILITY: Strip emojis from text (brand compliant)
  // ========================================
  function stripEmojis(text) {
    if (!text) return text;
    return text.replace(/[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2300}-\u{23FF}]|[\u{2B50}]|[\u{1FA00}-\u{1FAFF}]|[\u{FE00}-\u{FE0F}]|[\u{200D}]|[✨🎆🎉🎄🎁💕💐☘️🦃🔥🎃👻🇺🇸👔⚠️🛒❤️❄️🌸🌷🌺🌹🍂🍁🍃🏷️🕷️💀🦇💎📸✏️⚙️🎀]/gu, '').trim();
  }

  // ========================================
  // PREMIUM SVG ICONS (No emojis - brand compliant)
  // ========================================
  const ICONS = {
    sparkle: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 0L14.59 8.41L23 11L14.59 13.59L12 22L9.41 13.59L1 11L9.41 8.41L12 0Z"/></svg>',
    heart: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>',
    clover: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 2C9.79 2 8 3.79 8 6c0 1.1.45 2.1 1.17 2.83L12 12l2.83-3.17C15.55 8.1 16 7.1 16 6c0-2.21-1.79-4-4-4zm-6 6c-2.21 0-4 1.79-4 4s1.79 4 4 4c1.1 0 2.1-.45 2.83-1.17L12 12l-3.17-2.83C8.1 8.45 7.1 8 6 8zm12 0c-1.1 0-2.1.45-2.83 1.17L12 12l3.17 2.83C15.9 15.55 16.9 16 18 16c2.21 0 4-1.79 4-4s-1.79-4-4-4zm-6 6l-2.83 3.17C8.45 17.9 8 18.9 8 20c0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.1-.45-2.1-1.17-2.83L12 14z"/></svg>',
    flower: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 3.12 13.38 2 12 2S9.5 3.12 9.5 4.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"/></svg>',
    gift: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/></svg>',
    star: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>',
    moon: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/></svg>',
    leaf: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75C7 8 17 8 17 8z"/></svg>',
    flame: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"/></svg>',
    tree: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d="M12 2L4.5 20h3l1.5-4h6l1.5 4h3L12 2zm-1.27 12l1.27-3.67L13.27 14h-2.54zM11 22v-4h2v4h-2z"/></svg>',
    ring: '<svg class="tp-holiday-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/></svg>'
  };

  // Holiday greetings for footer
  const FOOTER_GREETINGS = {
    newYear: { icon: ICONS.sparkle, text: 'Wishing You a Brilliant New Year 2026' },
    valentines: { icon: ICONS.heart, text: 'Share the Love This Valentine\'s Day' },
    stPatricks: { icon: ICONS.clover, text: 'May Luck Be With You' },
    easter: { icon: ICONS.flower, text: 'Happy Spring from 3 Tinkers Pink' },
    mothersDay: { icon: ICONS.flower, text: 'Celebrating Amazing Mothers Everywhere' },
    fathersDay: { icon: ICONS.gift, text: 'Honoring Incredible Fathers' },
    july4th: { icon: ICONS.star, text: 'Celebrating Freedom & Love' },
    halloween: { icon: ICONS.moon, text: 'Have a Hauntingly Beautiful Day' },
    thanksgiving: { icon: ICONS.leaf, text: 'Grateful for You' },
    blackFriday: { icon: ICONS.flame, text: 'Thanks for Shopping With Us' },
    christmas: { icon: ICONS.tree, text: 'Wishing You Joy This Holiday Season' }
  };

  // Holiday messages for cart drawer
  const CART_MESSAGES = {
    newYear: { icon: ICONS.sparkle, text: 'New Year Special — Free Engraving' },
    valentines: { icon: ICONS.heart, text: 'Valentine\'s Gift — Premium Box Included' },
    stPatricks: { icon: ICONS.clover, text: 'Lucky Deal — Free Shipping' },
    easter: { icon: ICONS.flower, text: 'Spring Special — New Designs Available' },
    mothersDay: { icon: ICONS.flower, text: 'For Mom — Free Gift Wrap' },
    fathersDay: { icon: ICONS.gift, text: 'For Dad — Gift Box Included' },
    july4th: { icon: ICONS.star, text: 'Freedom Sale — 20% Applied' },
    halloween: { icon: ICONS.moon, text: 'Spooky Savings Inside' },
    thanksgiving: { icon: ICONS.leaf, text: 'Thankful Savings — Free Ship $50+' },
    blackFriday: { icon: ICONS.flame, text: 'BLACK FRIDAY — Max Savings' },
    christmas: { icon: ICONS.tree, text: 'Holiday Gift — Express Shipping' }
  };

  // Holiday messages for product pages
  const PRODUCT_MESSAGES = {
    newYear: { icon: ICONS.sparkle, text: 'New Year Special — Free Engraving Included' },
    valentines: { icon: ICONS.heart, text: 'Valentine\'s Gift — Ships in Premium Gift Box' },
    stPatricks: { icon: ICONS.clover, text: 'Lucky You — Free Shipping This Weekend' },
    easter: { icon: ICONS.flower, text: 'Spring Special — New Spring Designs' },
    mothersDay: { icon: ICONS.flower, text: 'Perfect for Mom — Free Gift Wrapping' },
    fathersDay: { icon: ICONS.gift, text: 'For Dad — Premium Gift Box Included' },
    july4th: { icon: ICONS.star, text: 'Independence Sale — 20% Off Today' },
    halloween: { icon: ICONS.moon, text: 'Spooky Deal — 15% Off This Ring' },
    thanksgiving: { icon: ICONS.leaf, text: 'Give Thanks — Free Shipping on $50+' },
    blackFriday: { icon: ICONS.flame, text: 'BLACK FRIDAY — Biggest Sale of the Year' },
    christmas: { icon: ICONS.tree, text: 'Holiday Gift — Free Express Shipping' }
  };

  // Update product page with holiday theming
  HolidayEngine.updateProductPage = function() {
    if (!this.currentHoliday) return;
    
    const holiday = this.currentHoliday;
    const holidayKey = holiday.key;
    
    // Only on product pages
    if (!window.location.pathname.includes('/products/')) return;
    
    console.log('Updating product page for holiday:', holidayKey);
    
    // Set holiday badge data attribute on product info
    const productInfo = document.querySelector('.tp-product-info, .product-info, [class*="product-info"]');
    if (productInfo) {
      productInfo.setAttribute('data-holiday-badge', holiday.badge || 'Holiday Special');
    }
    
    // Add holiday message above Add to Cart
    const addToCartSection = document.querySelector('.tp-add-to-cart-section, .tp-buy-buttons, [class*="add-to-cart"], .product-form__buttons');
    const message = PRODUCT_MESSAGES[holidayKey];
    
    if (addToCartSection && message && !document.querySelector('.tp-holiday-product-message')) {
      const messageEl = document.createElement('div');
      messageEl.className = 'tp-holiday-product-message';
      messageEl.innerHTML = `
        <p class="tp-holiday-product-message__text">
          ${message.icon}
          <span>${message.text}</span>
          ${message.icon}
        </p>
      `;
      addToCartSection.parentNode.insertBefore(messageEl, addToCartSection);
      console.log('Holiday message added to product page');
    }
    
    // Update Add to Cart button text for specific holidays
    const addToCartBtn = document.querySelector('.tp-add-to-cart-text, .tp-add-to-cart-btn span');
    if (addToCartBtn && holiday.ctaText) {
      // Keep original price but update action text
      const priceMatch = addToCartBtn.textContent.match(/\$[\d,.]+/);
      if (priceMatch) {
        addToCartBtn.innerHTML = addToCartBtn.innerHTML; // Keep as is for now
      }
    }
  };

  // Update cart drawer with holiday theming
  HolidayEngine.updateCartDrawer = function() {
    if (!this.currentHoliday) return;
    
    const holiday = this.currentHoliday;
    const holidayKey = holiday.key;
    const message = CART_MESSAGES[holidayKey];
    
    if (!message) return;
    
    // Function to add banner to cart drawer
    const addCartBanner = function() {
      const cartDrawer = document.querySelector('#cart-drawer');
      if (!cartDrawer) return;
      
      // Check if banner already exists
      if (cartDrawer.querySelector('.tp-holiday-cart-banner')) return;
      
      // Find the cart body/content area
      const cartBody = cartDrawer.querySelector('.drawer__body, .cart-drawer__body, [slot="body"]');
      if (!cartBody) return;
      
      // Create banner
      const banner = document.createElement('div');
      banner.className = 'tp-holiday-cart-banner';
      banner.innerHTML = `
        <p class="tp-holiday-cart-banner__text">
          <span>${message.icon}</span>
          ${message.text}
        </p>
      `;
      
      // Insert at top of cart body
      cartBody.insertBefore(banner, cartBody.firstChild);
      console.log('Holiday cart banner added');
    };
    
    // Try to add now
    addCartBanner();
    
    // Also add when cart drawer opens (mutation observer)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          setTimeout(addCartBanner, 100);
        }
      });
    });
    
    const cartDrawer = document.querySelector('#cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, { attributes: true });
    }
  };

  // Update footer with holiday greeting
  HolidayEngine.updateFooter = function() {
    if (!this.currentHoliday) return;
    
    const holiday = this.currentHoliday;
    const holidayKey = holiday.key;
    const greeting = FOOTER_GREETINGS[holidayKey];
    
    if (!greeting) return;
    
    // Find footer
    const footerSelectors = ['.tp-footer', '.tp-footer-mobile', 'footer', '[class*="footer"]'];
    
    for (const selector of footerSelectors) {
      const footer = document.querySelector(selector);
      if (footer && !footer.querySelector('.tp-holiday-footer-greeting')) {
        // Create greeting banner
        const greetingEl = document.createElement('div');
        greetingEl.className = 'tp-holiday-footer-greeting';
        greetingEl.innerHTML = `
          <p class="tp-holiday-footer-greeting__text">
            <span>${greeting.icon}</span>
            ${greeting.text}
            <span>${greeting.icon}</span>
          </p>
        `;
        
        // Insert at top of footer
        footer.insertBefore(greetingEl, footer.firstChild);
        console.log('Holiday footer greeting added to:', selector);
      }
    }
  };

  // 404 Page holiday messages
  const NOT_FOUND_MESSAGES = {
    newYear: 'Lost your way? Start fresh with a new ring for 2026!',
    valentines: 'Can\'t find what you\'re looking for? Let us help you find the perfect gift.',
    stPatricks: 'Feeling unlucky? Browse our lucky finds instead!',
    mothersDay: 'Page not found, but the perfect gift for Mom is just a click away.',
    fathersDay: 'Wrong turn? Find the perfect ring for Dad here.',
    july4th: 'Freedom to explore! Check out our collection.',
    halloween: 'Spooky! This page has vanished. Try our collection instead.',
    thanksgiving: 'Page not found, but we\'re thankful you\'re here!',
    blackFriday: 'This deal has ended, but more savings await!',
    christmas: 'This page took a holiday! Browse our gift collection.'
  };

  // Update 404 page with holiday theming
  HolidayEngine.update404Page = function() {
    if (!this.currentHoliday) return;
    
    const holiday = this.currentHoliday;
    const holidayKey = holiday.key;
    
    // Only on 404 pages
    const is404 = document.querySelector('.shopify-section--404');
    if (!is404) return;
    
    const message = NOT_FOUND_MESSAGES[holidayKey];
    if (!message) return;
    
    // Update the paragraph text
    const paragraph = is404.querySelector('p');
    if (paragraph) {
      paragraph.textContent = message;
    }
    
    console.log('[Holiday] 404 page themed');
  };

  // ========================================
  // SEARCH PAGE THEMING
  // ========================================
  const SEARCH_MESSAGES = {
    newyear: { icon: ICONS.sparkle, text: 'Ring in 2026 with the perfect band!' },
    valentines: { icon: ICONS.heart, text: 'Find a ring as special as your love' },
    stpatricks: { icon: ICONS.clover, text: 'Luck favors the bold - find your ring!' },
    easter: { icon: ICONS.flower, text: 'Spring into style with a new ring' },
    mothersday: { icon: ICONS.heart, text: 'Find the perfect gift for Mom' },
    memorialday: { icon: ICONS.star, text: 'Honor and remember with timeless style' },
    fathersday: { icon: ICONS.ring, text: 'Find the perfect ring for Dad' },
    july4: { icon: ICONS.star, text: 'Celebrate freedom with American craftsmanship' },
    laborday: { icon: ICONS.star, text: 'Labor Day deals on premium rings' },
    halloween: { icon: ICONS.moon, text: 'Spooktacular rings await...' },
    veteransday: { icon: ICONS.star, text: 'Honoring those who served' },
    thanksgiving: { icon: ICONS.leaf, text: 'Grateful for great rings!' },
    blackfriday: { icon: ICONS.flame, text: 'Biggest savings of the year!' },
    cybermonday: { icon: ICONS.flame, text: 'Cyber deals still going strong!' },
    christmas: { icon: ICONS.tree, text: 'Find the perfect gift under the tree' },
    default: { icon: ICONS.sparkle, text: 'Find your perfect ring' }
  };

  HolidayEngine.updateSearchPage = function() {
    const holiday = this.currentHoliday;
    if (!holiday) return;
    
    const holidayKey = holiday.key || 'default';
    const isSearchPage = window.location.pathname.includes('/search');
    
    if (!isSearchPage) return;
    
    const searchContent = document.querySelector('.tp-search-content');
    if (!searchContent) return;
    
    // Don't add if already exists
    if (document.querySelector('.tp-holiday-search-message')) return;
    
    const message = SEARCH_MESSAGES[holidayKey] || SEARCH_MESSAGES.default;
    
    // Create the holiday message banner
    const banner = document.createElement('div');
    banner.className = 'tp-holiday-search-message';
    banner.innerHTML = `
      <span class="tp-holiday-search-message__icon">${message.icon}</span>
      <span class="tp-holiday-search-message__text">${message.text}</span>
      <span class="tp-holiday-search-message__icon">${message.icon}</span>
    `;
    
    // Insert at the top of search content, after the search form
    const searchForm = searchContent.querySelector('.tp-search-form-wrap');
    if (searchForm && searchForm.nextSibling) {
      searchContent.insertBefore(banner, searchForm.nextSibling);
    } else {
      searchContent.insertBefore(banner, searchContent.firstChild);
    }
    
    console.log('[Holiday] Search page themed');
  };

  // Initialize on DOM ready
  function initHoliday() {
    HolidayEngine.loadSettings();
    HolidayEngine.init();
    HolidayEngine.updateHero();
    HolidayEngine.updateCollectionBanner();
    HolidayEngine.updatePopup();
    HolidayEngine.updateProductOverlay();
    HolidayEngine.updateProductPage();
    HolidayEngine.updateCartDrawer();
    HolidayEngine.updateFooter();
    HolidayEngine.update404Page();
    HolidayEngine.updateSearchPage();
    // Mark as loaded to reveal images with smooth transition
    requestAnimationFrame(() => {
      document.body.classList.add('tp-holiday-loaded');
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoliday);
  } else {
    initHoliday();
  }
  
  // Fallback: ensure images show after 500ms even if something fails
  setTimeout(() => {
    if (!document.body.classList.contains('tp-holiday-loaded')) {
      document.body.classList.add('tp-holiday-loaded');
    }
  }, 500);

  // Expose to window for testing
  window.HolidayEngine = HolidayEngine;

  // ========================================
  // SHOPIFY THEME EDITOR INTEGRATION
  // Re-apply holiday theme when settings change in customizer
  // ========================================
  document.addEventListener('shopify:section:load', function() {
    console.log('[Holiday] Section loaded - reinitializing');
    setTimeout(initHoliday, 100);
  });

  document.addEventListener('shopify:section:reorder', function() {
    console.log('[Holiday] Section reordered - reinitializing');
    setTimeout(initHoliday, 100);
  });

  // Watch for body class changes (when preview holiday changes)
  if (typeof MutationObserver !== 'undefined') {
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const bodyClasses = document.body.className;
          
          // Check if holiday class changed
          const holidayMatch = bodyClasses.match(/tp-holiday-(\w+)/g);
          let newHolidayKey = null;
          
          if (holidayMatch) {
            for (const match of holidayMatch) {
              const key = match.replace('tp-holiday-', '');
              if (key !== 'active' && key !== 'preview' && key !== 'loaded') {
                newHolidayKey = key;
                break;
              }
            }
          }
          
          // If holiday changed, reinitialize
          const currentKey = HolidayEngine.currentHoliday ? HolidayEngine.currentHoliday.key : null;
          if (newHolidayKey !== currentKey) {
            console.log('[Holiday] Body class changed from', currentKey, 'to', newHolidayKey);
            // Remove old classes first
            if (currentKey) {
              document.body.classList.remove('tp-holiday-' + currentKey);
            }
            setTimeout(initHoliday, 50);
          }
        }
      });
    });
    
    bodyObserver.observe(document.body, { attributes: true });
    console.log('[Holiday] MutationObserver active - watching for class changes');
  }

  // Also listen for Shopify's theme editor specific events
  if (window.Shopify && window.Shopify.designMode) {
    console.log('[Holiday] Design mode detected - enhanced editor integration active');
    
    // Poll for changes as fallback (customizer can be tricky)
    let lastBodyClass = document.body.className;
    setInterval(function() {
      if (document.body.className !== lastBodyClass) {
        console.log('[Holiday] Body class change detected via polling');
        lastBodyClass = document.body.className;
        setTimeout(initHoliday, 50);
      }
    }, 500);
  }

})();
